/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const getPermitType = (permit = {}, huntType = '') =>
    (permit.permit_types_list || []).find(({ id }) => id === huntType);
